module.exports = __webpack_public_path__ + "img/related-image-01.87cdccc6.jpg";